const { appConfig } = window['runtimeConfig'];

export default {
  toastSuccessDismissMs: appConfig.toastSuccessDismissMs,
  toastWarningDismissMs: appConfig.toastWarningDismissMs,
  toastErrorDismissMs: appConfig.toastErrorDismissMs
};
